import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import MonthCalendar, { Statuses as CalendarStatuses, Items } from '@/components/calendar/month';
import ExtButton from '@/components/ext/Button.vue';
import { Breadcrumbs as BreadcrumbsLayout, Extra as ExtraLayout } from '@/components/layout';
import { Yellow as FlexFilter } from '@/components/parts/filter';
import { TransitionFade } from '@/components/transition';
import PageError from '../../404.vue';
import Filter from '../filter';
import { CALENDAR_ROUTE } from '../const';
import Sections from '../sections';
import { Breadcrumbs } from '../types';
import { ACTION_FETCH, MONTHS, STORE_MODULE_NAME, TITLE_DEFAULT } from './const';
import createStoreModule from './store';
import { State as StateType, Statuses, Text, HavingId } from './types';
import { Route } from 'vue-router';

const { ERROR } = Statuses;
const StoreModule = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];

const isError = (value: any) => value === ERROR;

Component.registerHooks(['beforeRouteUpdate'])

@Component({
  components: {
    BreadcrumbsLayout,
    ExtButton,
    ExtraLayout,
    FlexFilter,
    MonthCalendar,
    PageError,
    TransitionFade,
  },
  metaInfo() {
    return {
      title: TITLE_DEFAULT,
    };
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PageActivityCalendar extends Mixins(Filter, Sections) {
  // Bindings
  @StoreModule.State('items')
  items: StateType['items'];

  @StoreModule.State
  month: StateType['month'];

  @StoreModule.State
  status: StateType['status'];

  @StoreModule.State
  year: StateType['year'];

  // Data
  visibleFilter: boolean = false;

  // Computed
  get breadcrumbsExtended(): Breadcrumbs {
    const year = String(this.year);
    const month = String(this.month);
    const params = { ...this.$route.params };
    return [
      ...this.breadcrumbSections,
      {
        text: year,
        to: {
          params,
          name: CALENDAR_ROUTE,
          query: { year },
        }
      },
      { text: MONTHS[month] },
    ];
  }

  get filterText(): Array<Text> {
    return this.filterFields.map(({ code, data, title }) => {
      const value = this.filterValues[code];
      let text = '';
      if (data) {
        const element = (data as Array<HavingId>).find(({ id }) => id === value);
        if (element) text = element.name;
      }
      return { text, title, value };
    });
  }

  get hasError(): boolean {
    return isError(this.status);
  }
  
  // TODO: Выяснить что сломается если я это удалю
  // @ts-ignore
  get routeName() {
    return CALENDAR_ROUTE;
  }
  
  // Hooks
  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.visibleFilter = false;
    next();
  }

  // AsyncData
  async asyncData({ store, route }: any) {
    const { section = '', subsection = '' } = route.params;
    const subSection = subsection;
    let { year, month } = route.query;

    if (!year) {
      const now = new Date();
      year = now.getFullYear();
      month = now.getMonth() + 1;
    }
    if (!month) month = 1;

    await fetch.call({ $store: store }, {
      ...route.query,
      year,
      month,
      section,
      subSection,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/calendar/script.ts